export default __webpack_public_path__ + "static/media/snake_image.96480be7.png";